/* eslint-disable */ export const freeGraphExplanation = `Esta es tu probabilidad de que no pierdas tu inversión y puedas tener ganancias si haces las cuatro apuestas arriba mencionadas con sus respectivas inversiones.`;

/* eslint-disable */ export const resetProfitText = `Si quieres regresar al rendimiento optimo, haz click en el siguiente botón:`;
